export const warehouseCards = {
    warehouseCard: {
        entity: 'warehouse',
        path: 'warehouse',
        titleBar: { mergeParams: ['name'], new: 'warehouse.form.new.title' },
        cardTitle: {
            title: 'warehouse.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'warehouse.form.dropdown.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'transact',
                    label: 'all.card.menu.transactions'
                },
                {
                    action: 'activate',
                    label: 'all.card.menu.activities'
                }

            ]
        },
        sections: [
            {
                id: 'warehouse',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'nameCode',
                        fields: [
                            {
                                type: 'text',
                                id: 'name',
                                label: 'warehouse.form.name',
                                placeholder: 'warehouse.form.name.placeholder',
                                required: true,
                                autoComplete: 'warehouse-name'
                            },
                            {
                                type: 'code',
                                id: 'code',
                                label: 'warehouse.form.code',
                                placeholder: 'warehouse.form.code.placeholder',
                                required: true,
                                autoComplete: 'warehouse-code'
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'warehouseTypeIdUseHalls',
                        fields: [
                            {
                                type: 'select',
                                id: 'warehouseTypeId',
                                displayField: 'warehouseTypeName',
                                label: 'inventory.warehouse.form.type',
                                entity: 'warehouseType',
                                valueMap: {
                                    'warehouseTypeId': 'id',
                                    'warehouseTypeName': 'name'
                                },
                                options: { withHeaders: true },
                                defaultValue: 'STORAGE'
                            },
                            {
                                type: 'switch',
                                id: 'useHalls',
                                invisibleLabel: true,
                                switchText: 'warehouse.form.useHalls'
                            }
                        ]
                    },
                    {
                        type: 'modal',
                        id: 'addressModal',
                        control: {
                            type: 'text',
                            id: 'addressModal',
                            label: 'warehouse.form.address',
                            placeholder: 'warehouse.form.address.placeholder'
                        },
                        descriptions: [
                            {
                                type: 'field',
                                field: 'address_street'
                            },
                            {
                                type: 'text',
                                text: ', '
                            },
                            {
                                type: 'field',
                                field: 'address_postCode'
                            },
                            {
                                type: 'text',
                                text: ' '
                            },
                            {
                                type: 'field',
                                field: 'address_city'
                            }
                        ],
                        modalForm: {
                            id: 'warehouseAddress',
                            elements: [
                                {
                                    type: 'text',
                                    id: 'address_name',
                                    label: 'warehouse.form.address.name',
                                    placeholder: 'warehouse.form.address.name_placeholder',
                                    focus: true,
                                    fgMargin: '1.5rem',
                                    autoComplete: 'address-name'
                                },
                                {
                                    type: 'text',
                                    id: 'address_street',
                                    label: 'warehouse.form.address',
                                    placeholder: 'warehouse.form.address.street',
                                    focus: true,
                                    fgMargin: '1.5rem',
                                    autoComplete: 'address-line1'
                                },
                                {
                                    type: 'group',
                                    id: 'addressPostCodeCity',
                                    label: 'warehouse.form.address',
                                    focus: false,
                                    fields: [
                                        {
                                            type: 'text',
                                            id: 'address_postCode',
                                            placeholder: 'warehouse.form.address.postcode',
                                            autoComplete: 'postal-code'
                                        },
                                        {
                                            type: 'text',
                                            id: 'address_city',
                                            placeholder: 'warehouse.form.address.city',
                                            focus: false,
                                            autoComplete: 'address-level2'

                                        },

                                    ]
                                }
                            ]
                        }
                    },
                    {
                        type: 'country',
                        id: 'country',
                        displayField: 'countryName',
                        label: 'all.country',
                        placeholder: 'warehouse.form.country',
                        name: 'country',
                        valueMap: {
                            'country': 'id',
                            'countryName': 'name',
                        },
                        defaultType: 'country'
                    },
                    {
                        type: 'modal',
                        id: 'zonesModal',
                        control: {
                            type: 'text',
                            id: 'zonesModal',
                            label: 'warehouse.zones.title',
                            placeholder: 'warehouse.zones.placeholder'
                        },
                        descriptions: [
                            { type: 'field', field: 'shippingHallName' },
                            { type: 'text', text: ' · ' },
                            { type: 'field', field: 'receivingHallName' }
                        ],
                        modalForm: {
                            id: 'warehouseZones',
                            elements: [
                                {
                                    type: 'connect',
                                    id: 'shippingHallId',
                                    displayField: 'shippingHallName',
                                    label: 'warehouse.zones.shipping',
                                    entity: 'warehouse/:id/hall',
                                    valueMap: { 'shippingHallId': 'id', 'shippingHallName': 'name' },
                                    options: { withHeaders: false },
                                    menuItemField: 'name',
                                    fgMargin: '1.5rem'
                                },
                                {
                                    type: 'connect',
                                    id: 'receivingHallId',
                                    displayField: 'receivingHallName',
                                    label: 'warehouse.zones.receiving',
                                    entity: 'warehouse/:id/hall',
                                    valueMap: { 'receivingHallId': 'id', 'receivingHallName': 'name' },
                                    options: { withHeaders: false },
                                    menuItemField: 'name',
                                    fgMargin: '1.5rem'
                                },
                                {
                                    type: 'connect',
                                    id: 'transferHallId',
                                    displayField: 'transferHallName',
                                    label: 'warehouse.zones.transfer',
                                    entity: 'warehouse/:id/hall',
                                    valueMap: { 'transferHallId': 'id', 'transferHallName': 'name' },
                                    options: { withHeaders: false },
                                    menuItemField: 'name',
                                    fgMargin: '1.5rem'
                                }
                            ]
                        }
                    }
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'warehouseCard.warehouse.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'name',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'name',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'countryName',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            }]
    },

    warehouseOrderCard: {
        entity: 'warehouseOrder',
        path: 'warehouseOrder',
        titleBar: { mergeParams: ['number'], new: 'warehouseOrder.form.new.title' },
        cardTitle: {
            title: 'warehouseOrder.form.menu.toggle',
            buttons: [
                { type: 'submit', id: 'warehouseOrderCard.save', action: 'save', label: 'all.form.button.save', icon: 'save', variant: 'primary' }
            ],
            menuItems: [
                { action: 'sequence', label: 'warehouseOrder.form.menu.sequence', confirm: false },
                { action: 'release', label: 'warehouseOrder.form.menu.release', confirm: false, preflight: true, modalConfig: 'warehouseOrderConfirmRelease', modalPreflight: 'warehouseOrderPreRelease' },
                { action: 'delete', label: 'warehouseOrder.form.menu.delete', confirm: true, modalConfig: 'confirmDelete' }
            ],
            actions: {
                sequence: { message: 'warehouseOrder.sequenceComplete', reload: true },
                release: { message: 'warehouseOrder.action.release.message', reload: true }
            }
        },
        tabs: [
            { key: 'lines', label: 'warehouseOrder.tab.lines' },
            { key: 'route', label: 'warehouseOrder.route.title', extension: 'warehouseOrderRoute' }
        ],
        afterSubmit: { navigateTo: '/warehouse/warehouseOrder', stay: true },
        sections: [
            {
                id: 'warehouseOrder.header',
                meta: { type: 'form', width: '800px' },
                groups: [
                    {
                        type: 'group',
                        id: 'numberDate',
                        fields: [
                            {
                                type: 'nserie',
                                id: 'number',
                                label: 'warehouseOrder.form.number',
                                placeholder: 'warehouseOrder.form.number.placeholder',
                                entity: 'warehouseOrder',
                                required: true,
                                defaultType: 'nserie'
                            },
                            {
                                type: 'date',
                                id: 'date',
                                label: 'warehouseOrder.form.date',
                                required: true,
                                defaultType: 'date',
                                align: 'right'
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'typeWarehouseId',
                        fields: [
                            {
                                type: 'select',
                                id: 'type',
                                displayField: 'typeName',
                                label: 'warehouseOrder.form.type',
                                entity: 'warehouseOrderType',
                                valueMap: { 'type': 'id', 'typeName': 'name' },
                                options: { withHeaders: false },
                                required: true,
                                defaultValue: 'TRANSFER'
                            },
                            {
                                type: 'connect',
                                id: 'warehouseId',
                                displayField: 'warehouseName',
                                label: 'warehouseOrder.form.warehouse',
                                placeholder: 'warehouseOrder.form.warehouse.placeholder',
                                modalTitle: 'warehouseOrder.form.warehouse.modal.title',
                                entity: 'warehouse',
                                valueMap: { 'warehouseId': 'id', 'warehouseName': 'name', 'warehouseCode': 'code' },
                                options: { withHeaders: false }
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'toWarehouseId',
                        fields: [
                            {
                                type: 'connect',
                                id: 'toWarehouseId',
                                displayField: 'toWarehouseName',
                                label: 'warehouseOrder.form.toWarehouse',
                                placeholder: 'warehouseOrder.form.toWarehouse.placeholder',
                                modalTitle: 'warehouseOrder.form.toWarehouse.modal.title',
                                entity: 'warehouse',
                                valueMap: { 'toWarehouseId': 'id', 'toWarehouseName': 'name', 'toWarehouseCode': 'code' },
                                options: { withHeaders: false }
                            }
                        ]
                    },
                    {
                        type: 'connect',
                        id: 'fromLocationId',
                        displayField: 'fromLocationId',
                        label: 'warehouseOrder.form.fromLocation',
                        placeholder: 'warehouseOrder.form.fromLocation.placeholder',
                        modalTitle: 'warehouseOrder.form.fromLocation.modal.title',
                        entity: 'location',
                        valueMap: { 'fromLocationId': 'id', 'fromLocationCode': 'id' },
                        options: { withHeaders: false },
                        menuItemField: 'id',
                        selectButtonKey: 'warehouseOrder.form.location.modal.select.button',
                        defaultRadioGroups: { warehouse: ['warehouseCode'] },
                        condition: { field: 'type', operator: 'equals', value: 'PUTAWAY' },
                        linkedFields: ['warehouseCode'],
                        modalType: 'radioGroup',
                        persistValue: true,
                        radioGroups: [
                            {
                                id: 'warehouse',
                                title: 'warehouseOrder.form.location.modal.warehouse',
                                entity: 'warehouse',
                                valueField: 'code',
                                idPrefix: 'W',
                                labelField: 'code',
                                icon: 'warehouse',
                                iconField: 'warehouseTypeId',
                                iconMap: { PRODUCTION: 'factory', STORAGE: 'warehouse' }
                            },
                            {
                                id: 'hall',
                                title: 'warehouseOrder.form.location.modal.hall',
                                entity: 'warehouse/:id/hall',
                                dependsOn: 'warehouse',
                                valueField: 'code',
                                labelField: 'code',
                                idPrefix: 'H',
                                icon: 'hall'
                            },
                            {
                                id: 'rack',
                                title: 'warehouseOrder.form.location.modal.rack',
                                entity: 'rack',
                                dependsOn: 'warehouse',
                                valueField: 'code',
                                labelField: 'code',
                                idPrefix: 'R',
                                columns: 6,
                                filter: [
                                    { param: 'warehouseCode', groupId: 'warehouse' },
                                    { param: 'hallCode', groupId: 'hall' }
                                ],
                                subRadio: [
                                    { id: 'level', idPrefix: 'L', valueField: 'totalLevels', title: 'warehouseOrder.form.location.modal.level', columns: 6, value: 'auto', optional: true },
                                    { id: 'position', idPrefix: 'P', valueField: 'totalPositions', title: 'warehouseOrder.form.location.modal.position', columns: 6, value: 'auto' }
                                ],
                            }
                        ]
                    },
                    {
                        type: 'connect',
                        id: 'toLocationId',
                        displayField: 'toLocationId',
                        label: 'warehouseOrder.form.toLocation',
                        placeholder: 'warehouseOrder.form.toLocation.placeholder',
                        modalTitle: 'warehouseOrder.form.toLocation.modal.title',
                        entity: 'location',
                        valueMap: { 'toLocationId': 'id', 'toLocationCode': 'id' },
                        options: { withHeaders: false },
                        menuItemField: 'id',
                        selectButtonKey: 'warehouseOrder.form.location.modal.select.button',
                        defaultRadioGroups: { warehouse: ['toWarehouseCode', 'warehouseCode'] },
                        condition: { field: 'type', operator: 'equals', value: 'PICK' },
                        linkedFields: ['toWarehouseCode', 'warehouseCode'],
                        modalType: 'radioGroup',
                        persistValue: true,
                        radioGroups: [
                            {
                                id: 'warehouse',
                                title: 'warehouseOrder.form.location.modal.warehouse',
                                entity: 'warehouse',
                                valueField: 'code',
                                idPrefix: 'W',
                                labelField: 'code',
                                icon: 'warehouse',
                                iconField: 'warehouseTypeId',
                                iconMap: { PRODUCTION: 'factory', STORAGE: 'warehouse' }
                            },
                            {
                                id: 'hall',
                                title: 'warehouseOrder.form.location.modal.hall',
                                entity: 'warehouse/:id/hall',
                                dependsOn: 'warehouse',
                                valueField: 'code',
                                labelField: 'code',
                                idPrefix: 'H',
                                icon: 'hall'
                            },
                            {
                                id: 'rack',
                                title: 'warehouseOrder.form.location.modal.rack',
                                entity: 'rack',
                                dependsOn: 'warehouse',
                                valueField: 'code',
                                labelField: 'code',
                                idPrefix: 'R',
                                columns: 6,
                                filter: [
                                    { param: 'warehouseCode', groupId: 'warehouse' },
                                    { param: 'hallCode', groupId: 'hall' }
                                ],
                                subRadio: [
                                    { id: 'level', idPrefix: 'L', valueField: 'totalLevels', title: 'warehouseOrder.form.location.modal.level', columns: 6, value: 'auto', optional: true },
                                    { id: 'position', idPrefix: 'P', valueField: 'totalPositions', title: 'warehouseOrder.form.location.modal.position', columns: 6, value: 'auto' }
                                ],
                            }
                        ]
                    },
                    {
                        type: 'connect',
                        id: 'assignedToId',
                        displayField: 'assignedToName',
                        label: 'warehouseOrder.form.assignedTo',
                        placeholder: 'warehouseOrder.form.assignedTo.placeholder',
                        modalTitle: 'warehouseOrder.form.assignedTo.modal.title',
                        entity: 'employee',
                        valueMap: { 'assignedToId': 'id', 'assignedToName': 'name' },
                        options: { withHeaders: false }
                    },
                    { type: 'textarea', id: 'note', label: 'warehouseOrder.form.note', rows: 3 }
                ],
                buttons: [
                    { type: 'button', id: 'warehouseOrderCard.header.close', action: 'close', label: 'all.form.button.save', variant: 'primary' }
                ],
                displaySection: {
                    emptyField: 'number',
                    columns: [
                        {
                            weight: 4, basis: '40%',
                            elements: [
                                { type: 'field', value: 'number', scale: 'title' },
                                { type: 'field', value: 'typeName', scale: 'normal' },
                                { type: 'date', value: 'date', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 6, basis: '60%', align: 'right',
                            elements: [
                                { type: 'field', value: 'warehouseName', scale: 'title' },
                                { type: 'field', value: 'assignedToName', scale: 'normal' }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'warehouseOrder.lines',
                meta: {
                    type: 'lines',
                    tab: 'lines',
                    linesArray: 'lines',
                    linesAddAction: 'warehouseOrder.form.line.add',
                    width: '800px',
                },
                groups: [
                    {
                        type: 'connect',
                        id: 'itemId',
                        displayField: 'itemName',
                        label: 'warehouseOrder.form.line.item',
                        placeholder: 'warehouseOrder.form.line.item.placeholder',
                        modalTitle: 'warehouseOrder.form.line.item.modal.title',
                        entity: 'product',
                        valueMap: {
                            'itemId': 'id',
                            'itemName': 'name',
                            'itemSku': 'sku',
                            'unitId': 'unitId',
                            'unitName': 'unitName',
                        },
                        options: { withHeaders: true },
                        required: true
                    },
                    {
                        type: 'group',
                        id: 'quantityUnitId',
                        focus: false,
                        fields: [
                            {
                                type: 'number',
                                id: 'quantity',
                                label: 'warehouseOrder.form.line.quantity',
                                placeholder: 'warehouseOrder.form.line.quantity',
                                required: true,
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'quantity'
                            },
                            {
                                type: 'select',
                                id: 'unitId',
                                displayField: 'unitName',
                                label: 'warehouseOrder.form.line.unit',
                                placeholder: 'warehouseOrder.form.line.unit.placeholder',
                                entity: 'unit',
                                valueMap: { 'unitName': 'name', 'unitId': 'id' },
                                options: { withHeaders: true },
                                required: true
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'fromToLocationId',
                        fields: [
                            {
                                type: "modal",
                                id: 'fromLocationId',
                                emptyMessage: "warehouseOrder.form.line.fromLocation.empty",
                                disableOnMissing: 'itemId',
                                control: {
                                    type: "text",
                                    id: "fromLocationsModal",
                                    label: "warehouseOrder.form.line.fromLocation",
                                    placeholder: "warehouseOrder.form.line.fromLocation.placeholder"
                                },
                                descriptions: [
                                    { type: "field", field: "fromLocationId" }
                                ],
                                modalFormRef: 'selectFromLocationWarehouse'
                            },
                            {
                                type: 'connect',
                                id: 'toLocationId',
                                displayField: 'toLocationId',
                                label: 'warehouseOrder.form.line.toLocation',
                                placeholder: 'warehouseOrder.form.line.toLocation.placeholder',
                                modalTitle: 'warehouseOrder.form.line.toLocation.modal.title',
                                entity: 'location',
                                valueMap: {
                                    'toLocationId': 'id',
                                    'toLocationCode': 'id',
                                },
                                options: { withHeaders: false },
                                menuItemField: 'id',
                                selectButtonKey: 'warehouseOrder.form.location.modal.select.button',
                                defaultRadioGroups: { warehouse: ['toWarehouseCode', 'warehouseCode'] },
                                linkedFields: ['toWarehouseCode', 'warehouseCode'],
                                modalType: 'radioGroup',
                                persistValue: true,
                                radioGroups: [
                                    {
                                        id: 'warehouse',
                                        title: 'warehouseOrder.form.location.modal.warehouse',
                                        entity: 'warehouse',
                                        valueField: 'code',
                                        idPrefix: 'W',
                                        labelField: 'code',
                                        icon: 'warehouse',
                                        iconField: 'warehouseTypeId',
                                        iconMap: { PRODUCTION: 'factory', STORAGE: 'warehouse' }
                                    },
                                    {
                                        id: 'hall',
                                        title: 'warehouseOrder.form.location.modal.hall',
                                        entity: 'warehouse/:id/hall',
                                        dependsOn: 'warehouse',
                                        valueField: 'code',
                                        labelField: 'code',
                                        idPrefix: 'H',
                                        icon: 'hall'
                                    },
                                    {
                                        id: 'rack',
                                        title: 'warehouseOrder.form.location.modal.rack',
                                        entity: 'rack',
                                        dependsOn: 'warehouse',
                                        valueField: 'code',
                                        labelField: 'code',
                                        idPrefix: 'R',
                                        columns: 6,
                                        filter: [
                                            { param: 'warehouseCode', groupId: 'warehouse' },
                                            { param: 'hallCode', groupId: 'hall' }
                                        ],
                                        subRadio: [
                                            { id: 'level', idPrefix: 'L', valueField: 'totalLevels', title: 'warehouseOrder.form.location.modal.level', columns: 6, value: 'auto', optional: true },
                                            { id: 'position', idPrefix: 'P', valueField: 'totalPositions', title: 'warehouseOrder.form.location.modal.position', columns: 6, value: 'auto' }
                                        ],
                                    }
                                ]
                            }
                        ]
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'warehouseOrderCard.lines.delete',
                        action: 'delete',
                        label: 'all.form.button.delete',
                        icon: 'delete',
                        variant: 'danger',
                        size: 'icon'
                    },
                    {
                        type: 'button',
                        id: 'warehouseOrderCard.lines.save',
                        action: 'save',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'itemName',
                    emptyMessage: 'warehouseOrder.form.line.missing',
                    editButtonRightOffset: '25%',
                    columns: [
                        {
                            weight: 7, basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'quantity'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} → ${2}',
                                    mergeParams: ['fromLocationId', 'toLocationId'],
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3, basis: '30%', align: 'end',
                            elements: [
                                { type: 'amount', value: 'quantity', scale: 'title', variant: 'noMargin' },
                                { type: 'field', value: 'unitName', scale: 'normal', variant: 'noMargin' }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    warehousePathCard: {
        entity: 'warehousePath',
        path: 'warehousePath',
        titleBar: { mergeParams: ['name'], new: 'warehousePath.form.new.title' },
        cardTitle: {
            title: 'warehousePath.form.dropdown.toggle',
            menuItems: [
                { action: 'delete', label: 'warehousePath.form.delete', confirm: true, modalConfig: 'confirmDelete' }
            ]
        },
        sections: [
            {
                id: 'warehousePath',
                meta: { type: 'form', width: '600px' },
                groups: [
                    {
                        type: 'text',
                        id: 'name',
                        label: 'warehousePath.form.name',
                        placeholder: 'warehousePath.form.name.placeholder',
                        required: true
                    },
                    {
                        type: 'connect',
                        id: 'warehouseId',
                        displayField: 'warehouseName',
                        label: 'warehousePath.form.warehouse',
                        placeholder: 'warehousePath.form.warehouse.placeholder',
                        modalTitle: 'warehousePath.form.warehouse.modal.title',
                        entity: 'warehouse',
                        valueMap: { 'warehouseId': 'id', 'warehouseName': 'name', 'warehouseCode': 'code' },
                        options: { withHeaders: false },
                        required: true
                    },
                    {
                        type: 'radio',
                        id: 'pathType',
                        label: 'warehousePath.form.type',
                        options: [
                            { value: 'AISLE', label: 'warehousePath.form.type.aisle' },
                            { value: 'CORRIDOR', label: 'warehousePath.form.type.corridor' },
                            { value: 'HALL_LINK', label: 'warehousePath.form.type.hallLink' },
                            { value: 'OUTDOOR', label: 'warehousePath.form.type.outdoor' }
                        ],
                        defaultValue: 'AISLE'
                    },
                    {
                        type: 'number',
                        id: 'width',
                        label: 'warehousePath.form.width',
                        decimals: 0,
                        variant: 'quantity'
                    }
                ],
                buttons: [
                    { type: 'submit', id: 'warehousePathCard.warehousePath.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }
                ],
                displaySection: {
                    emptyField: 'name',
                    columns: [{ weight: 1, basis: '100%', elements: [{ type: 'field', value: 'name', scale: 'title' }] }]
                }
            }
        ]
    },
}
